import { Box, Divider, styled } from '@mui/material';
import ReactMarkdown, { type Options } from 'react-markdown';

import { PreviewMarkdownBaseElement as Element } from './PreviewMarkdownBaseElement';
import { PreviewMarkdownCodeElement } from './PreviewMarkdownCodeElement';
import { PreviewMarkdownLinkElement } from './PreviewMarkdownLinkElement';
import { CodeElementProps } from './types';
import { SxProps } from '../../types';

export type PreviewMarkdownProps = {
  markdown: string;
  components?: Options['components'];
  sx?: SxProps;
};

const StyledContainer = styled(Box, {
  name: 'DsPreviewMarkdown',
  slot: 'Root',
  overridesResolver: (_, theme) => {
    return [theme.root];
  },
})``;

export const PreviewMarkdown = ({
  markdown,
  components,
  ...props
}: PreviewMarkdownProps) => {
  return (
    <StyledContainer {...props}>
      <ReactMarkdown
        components={{
          h1: ({ children }) => (
            <Element type="h1" as="h1">
              {children}
            </Element>
          ),
          h2: ({ children }) => (
            <Element type="h2" as="h2">
              {children}
            </Element>
          ),
          h3: ({ children }) => (
            <Element type="h3" as="h3">
              {children}
            </Element>
          ),
          h4: ({ children }) => (
            <Element type="h4" as="h4">
              {children}
            </Element>
          ),
          h5: ({ children }) => (
            <Element type="h5" as="h5">
              {children}
            </Element>
          ),
          strong: ({ children }) => (
            <Element type="strong" as="strong">
              {children}
            </Element>
          ),
          p: ({ children }) => (
            <Element type="p" as="p">
              {children}
            </Element>
          ),
          ol: ({ children }) => (
            <Element type="ol" as="ol">
              {children}
            </Element>
          ),
          ul: ({ children }) => (
            <Element type="ul" as="ul">
              {children}
            </Element>
          ),
          blockquote: ({ children }) => (
            <Element type="blockquote" as="blockquote">
              {children}
            </Element>
          ),
          code: (props: CodeElementProps) => {
            return <PreviewMarkdownCodeElement {...props} />;
          },
          hr: () => <Divider className="DsPreviewMarkdown-Divider" />,
          a: ({ href, children }) => {
            return (
              <PreviewMarkdownLinkElement
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {children}
              </PreviewMarkdownLinkElement>
            );
          },
          ...components,
        }}
      >
        {markdown}
      </ReactMarkdown>
    </StyledContainer>
  );
};
